export enum MediaPlayerRepeatMode {
  NoRepeat = 0,
  RepeatPlaylist,
  RepeatSong
}